<template>
  <RevButton v-if="!error" :to="url" variant="primary">
    <slot></slot>
  </RevButton>
</template>

<script setup lang="ts">
import { RevButton } from '@ds/components/Button'

import { useStudentVerificationUrl } from './useStudentVerificationUrl'

const { url, error } = useStudentVerificationUrl()
</script>
